import type { AuthState } from '@web/app/features/auth'
import { authReducer } from '@web/app/features/auth'
import type { PersistConfig } from 'redux-persist'
import { persistReducer } from 'redux-persist'

const AsyncStorage = {
  getItem: async (key: string): Promise<string | null> => {
    try {
      return localStorage.getItem(key)
    } catch (error) {
      console.error('Error getting item from localStorage:', error)
      return null
    }
  },
  setItem: async (key: string, value: string): Promise<void> => {
    try {
      localStorage.setItem(key, value)
    } catch (error) {
      console.error('Error setting item in localStorage:', error)
      throw error
    }
  },
  removeItem: async (key: string): Promise<void> => {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error('Error removing item from localStorage:', error)
      throw error
    }
  },
}

const config: PersistConfig<AuthState> = {
  key: 'auth', // Use a static key for persistence
  storage: AsyncStorage,
  whitelist: ['authData', 'isDemo'],
}

export const persistedAuthReducer = {
  auth: persistReducer(config, authReducer),
}
